/* unplugin-vue-components disabled */import script from "./DiscountDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./DiscountDetails.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__